const Input = require("components/forms/Input");
const Address = require("components/forms/Address");
const Phone = require("components/forms/Phone");
const Form = require("components/forms/Form");
const PropTypes = require("prop-types");
const userStore = require("stores/UserStore");
const Section = require("components/forms/Section");
const moment = require("moment");
const Date = require("components/forms/Date");
const shortid = require("shortid");

class OverviewForm extends Form {

	static get propTypes() {
		return {
			handleSubmit: PropTypes.func
		};
	}

	get maxBirthdayDate() {
		return moment().toISOString();
		// TODO: Add proper limit
		//return moment().subtract(18, "years").toISOString();
	}

	value(name) {
		return userStore.get(name);
	}

	send(form) {
		return userStore.save(new FormData(form));
	}

	renderBody() {
		return (
			<div className="form-body">
				<Section title=""/>
				<Input label="Fulde navn" name="name" required={true} error={this.error("name")}
							 defaultValue={this.value("name")}/>

				<Date label="Fødselsdag" type="text" name="birthday" required={true}
							max={this.maxBirthdayDate} defaultValue={this.value("birthday")} error={this.error("birthday")}/>

				<Address types="address" componentRestrictions={{country: "dk"}}
								 label="Adresse" name="address" autoComplete="user-address" required={true}
								 defaultValue={this.value("address")} error={this.error("address")} placeholder=""/>

				<Input label="Email" type="email" name="email" required={true}
							 defaultValue={this.value("email")} error={this.error("email")} autoComplete={shortid.generate()}/>

				<Phone label="Telefon" name="phone" required={true}
							 defaultValue={this.value("phone")} error={this.error("phone")}/>

				{this.props.children}
			</div>
		);
	}

	renderFooter() {
		// ...
	}

}

module.exports = OverviewForm;


// WEBPACK FOOTER //
// ./resources/js/components/checkout/OverviewForm.js